import type { ReactNode } from 'react';

export function highlightAddressMatch(optionValue: string, inputValue: string): ReactNode {
    if (!optionValue || !inputValue) return optionValue;

    const terms = inputValue
        .split(',')
        .map((t) => t.trim().toLowerCase())
        .filter(Boolean);

    if (!terms.length) return optionValue;

    const parts: ReactNode[] = [];
    let remaining = optionValue;
    let offset = 0;

    terms.forEach((term) => {
        const idx = remaining.toLowerCase().indexOf(term);
        if (idx === -1) return;

        parts.push(remaining.slice(0, idx));
        parts.push(
            <b className="query" key={offset}>
                {remaining.slice(idx, idx + term.length)}
            </b>,
        );
        remaining = remaining.slice(idx + term.length);
        offset += 1;
    });

    parts.push(remaining);
    return <>{parts}</>;
}
